export default __webpack_public_path__ + "static/media/Conan.c616da33.jpg";